import './Timeline.scss';
import Slider from 'react-slick';

import first from '../img/timeline-final/001-2017 Első randik .JPG';
import second from '../img/timeline-final/002portrait.png'
import third from '../img/timeline-final/003-Első közös USA 2018.JPG';
import fourth from '../img/timeline-final/004-Dead Sea 2019.JPG';
import fifth from '../img/timeline-final/005-istambul2021.png';
import sixth from '../img/timeline-final/006-harman-2022.png';
import seventh from '../img/timeline-final/007madrid-2023.png';
import eighth from '../img/timeline-final/008-💍2024.JPG';
import { useI18n } from '../i18n/i18n';

const images = [
    first,
    second,
    third,
    fourth,
    fifth,
    sixth,
    seventh,
    eighth
];

const settings = {
    dots: true,
    arrows: false,
}

export function Timeline() {
    const t = useI18n();

    const renderBlock = (img, text, index) => {
        return <div key={index} className="img-frame">
            <img src={img} alt={text} />
            <div>{text.split(' - ').map((part, key) => <div key={key}>{part}</div>)}</div>
        </div>;
    };
    return <div className="timeline-slider">
        <h2>{t.timeline.h2}</h2>
        <div className="slider">
            <Slider {...settings}>
                {images.map((img, index) => renderBlock(img, t.timeline.milestones[index], index))}
            </Slider>
        </div>
    </div>;
}
